<section class=" fjCRKo">
    <img class="sc-4k3xr3-0 llrJEY" src="assets/img/slide.jpg" sizes="100vm" alt="">
    <div class="sc-1rpwfyc-0 iMiWpR">

        <h3 class="home_text">
            ATTIRER,
            RECRUTER,
            DEVELOPPER, GERER ET FIDELISER des
            talents pour
            l'Afrique !</h3>

        <div style="text-align: center;">
            <a routerLink="a-propos/talents-plus-afrique" class="btn btn-submit-plus">Voir plus</a>
            <a href="contact" class="btn btn-submit-second">Contactez-nous</a>
        </div>
    </div>
</section>

<section
    style="background:url(assets/img/back-produits.svg); background-size: cover; background-position: center; background-repeat: no-repeat;">
    <div class="container">
        <app-autresites></app-autresites>
    </div>
</section>
<section style="padding: 20px 0px 20px; ">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-5 col-lg-5" style="display: flex;
    align-items: center;">
                <img class="assets/img-about" style="width: 100%;" src="assets/img/tpa.jpg">
            </div>
            <div class="col-12 col-sm-7 col-lg-7" style="margin: auto;">
                <!-- <p class="section-title">Qui sommes-nous ?</p> -->
                <h1 class="title-present" style="color: #00027D; font-weight: bold;">Qui sommes-nous ?</h1>

                <p style="font-size: 15px; text-align: justify;">Créé il y a plus de 18ans, <b> TALENTS PLUS
                        AFRIQUE </b>
                    vous accompagne dans vos enjeux RH : <b>Travail temporaire, Assistance aux entreprises, Formation
                        (Intra et Inter entreprise, Individuelle, E-learning, Coaching), Conseils aux PME/PMI, Etudes RH
                        générale
                        et SIRH </b> à
                    l’international au travers de 05 filiales implantées dans 04 pays.</p>
                <div class="pays-list" style="margin-top: 10px">
                    <a href="/filiales/talents-plus-conseils-benin"><img src="assets/img/benin.svg">Bénin</a>
                    <a href="/filiales/talents-plus-conseils-cote-divoire"><img src="assets/img/cote.svg">Côte
                        d'ivoire</a>
                    <a href="/filiales/talents-plus-ett-togo"><img src="assets/img/togo.svg">Togo</a>
                    <a href="/filiales/talents-plus-conseils-mali"><img src="assets/img/mali.svg">Mali</a>

                </div>
                <a routerLink="a-propos/talents-plus-afrique" class="btn btn-submit-second">Nous découvrir</a>
            </div>
        </div>
    </div>
</section>
<section
    style="padding: 20px 0px 10px; background: url('assets/img/back-about.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-sm-4 col-lg-4" style="display: flex;
    flex-direction: row;
    align-items: center;">
                <h2 class="implantation" style="color: #00027D; font-weight: bold;font-size: 25px !important;">Nos
                    engagements</h2>

            </div>
            <div class="col-12 col-sm-4 col-lg-4">
                <div class="about-pays">
                    <ul>
                        <li class="" style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2 "
                                aria-hidden="true"></i>Efficacité</li>
                        <li style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2"
                                aria-hidden="true"></i>Exigence
                        </li>
                        <li style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2" aria-hidden="true"></i>Equité
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-12 col-sm-4 col-lg-4">

                <ul>
                    <li style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2" aria-hidden="true"></i>Ethique
                    </li>
                    <li style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2" aria-hidden="true"></i>Agilité
                    </li>
                    <li style=" font-weight: bold;"><i class="fa fa-hand-o-right mr-2"
                            aria-hidden="true"></i>Bienveillance</li>

                </ul>
            </div>
        </div>
    </div>
</section>
<section class="testimonials">
    <div class="container p-5">
        <h2 class="customize-title mb-3 " style="text-align: center !important;">Nos certifications et
            agréments</h2>
        <div class="row">
            <div class="col-lg-4  col-12 col-sm-6 " style="display: flex;
    align-items: center;">
                <img src="assets/img/interteck.png" alt="">
            </div>
            <div class="col-lg-8  col-12 col-sm-6 ">
                <p class="text-justify "><b>Les prestations de formations de Talents Plus Conseils Bénin ont
                        reçu la
                        certification qualité ISO
                        29993 V 2017 –
                        Qualité des organismes de formation.</b> ISO 29993 V 2017 est le gage de qualité d’un
                    référentiel
                    rigoureux reconnu à
                    l’international. C’est
                    dorénavant, votre
                    critère objectif supplémentaire qui justifie votre préférence et votre confiance en la qualité et en
                    l’efficacité de nos
                    ateliers de formations. Cette certification des services de formations de Talents Plus Conseils est
                    délivrée par <b>INTERTEK</b></p>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-8  col-12 col-sm-6 ">
                <p class="text-justify ">Le Cabinet est également habilité comme Centre de Formation
                    Professionnelle Continue par le MTFP ( Ministère du Travail et de la Fonction Publique) du Bénin à
                    travers la Direction
                    Générale de Renforcement des Capacités et de l'Employabilité (DGRCE) et le Fonds de Développement de
                    la Formation Professionnelle Continue et de l'Apprentissage (FODEFCA), le FDFP (Fonds de
                    Dévéloppement de Formation Professionnelle) en Côte d'Ivoire et
                    le FAFPA (Fonds d'Appui à la Formation Professionnelle et à l'Apprentissage) au Mali.</p>
            </div>
            <div class="col-lg-4  col-12 col-sm-6 " style="display: flex;
    align-items: center;">
                <img src="assets/img/part.jpg" alt="">
            </div>
        </div>
    </div>
</section>

<section class=""
    style="padding: 20px 0px 10px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat; color: #fff;">
    <div class="container">
        <div style="text-align: center; margin-bottom: 30px;">
            <h2 class="customize-title" style="color: #fff; font-weight: bold;">Nos valeurs</h2>
        </div>
        <div class="row">
            <div class=" col-12 col-sm-6 col-lg-3">
                <div class="avant">
                    <img width="30" src="assets/img/award.svg">
                    <div>
                        <h4>JEUNESSE D’ESPRIT
                        </h4>
                        <p>Ouverture d’esprit - Adaptation permanente - Fougue et Energie
                        </p>
                    </div>
                </div>
            </div>
            <div class=" col-12 col-sm-6 col-lg-3">
                <div class="avant">
                    <img width="30" src="assets/img/award.svg">
                    <div>
                        <h4>OBLIGATION DE RESULTATS
                        </h4>
                        <p>Professionnalisme - Standards internationaux/Qualité - Discipline
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="avant">
                    <img width="30" src="assets/img/award.svg">
                    <div>
                        <h4>INNOVATION </h4>
                        <p>Pionnier dans nos domaines - Amélioration continue - Pionnier dans la digitalisation
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <div class="avant">
                    <img width="30" src="assets/img/award.svg">
                    <div>
                        <h4>ETHIQUE</h4>
                        <p>Fidélité - Sens de l’honneur - Fiabilité
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="produits"
    style="background:url(assets/img/back-produits.svg); background-size: cover; background-position: center; background-repeat: no-repeat;">
    <div class="container">
        <div style="text-align: center; margin-bottom: 30px;">
            <h2 class="customize-title">Nos produits</h2>
        </div>
        <div class="row">
            <div class="col-12 col-sm-6 col-lg-4">
                <a routerLink="nos-produits/travail-temporaire">
                    <div class="produits-card">
                        <div class="image-back">
                            <div class="image"></div>
                        </div>
                        <h4 style="">Travail temporaire/Portage</h4>
                        <p>Une agence spécialisée dans le recrutement et la mise à disposition de personnel
                            temporaire.
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
                <a routerLink="nos-produits/recrutement">
                    <div class="produits-card">
                        <div class="image-back">
                            <div class="image2"></div>
                        </div>
                        <h4 style="">Recrutement</h4>
                        <p>Nous assurons l'ensemble du processus de recrutement : publication, collecte et traitement
                            des dossiers.
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-12 col-sm-12 col-lg-4">
                <a routerLink="nos-produits/formation">
                    <div class="produits-card">
                        <div class="image-back">
                            <div class="image3"></div>
                        </div>
                        <h4 style="">Formation</h4>
                        <p>Nos formations sont diffusées par des professionnels de références dans leurs domaines.</p>
                    </div>
                </a>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 pb-5">
                <a routerLink="nos-produits/conseil-pme-pmi">
                    <div class="produits-card1">
                        <div class="image-back">
                            <div class="image4"></div>
                        </div>
                        <h4 style="">Conseils PME/PMI</h4>
                        <p>
                            Nos interventions sont sur mesures et adaptées à vos besoins dans des conditions optimales
                            par des experts
                            en accompagnement et conseils
                        </p>
                    </div>
                </a>
            </div>
            <div class="col-12 col-sm-6 col-lg-4">
                <a routerLink="nos-produits/etudes-rh">
                    <div class="produits-card1">
                        <div class="image-back">
                            <div class="image6"></div>
                        </div>
                        <h4 style="">Etude RH/Général</h4>
                        <p>Nous assurons l'ensemble de nos études à travers la démarche professionnelle qui suit :
                            collecte des
                            données, diagnostic, analyse et traitement des données, rapport provisoire et final. </p>
                    </div>
                </a>
            </div>
            <div class="col-12 col-sm-6 col-lg-4 ">
                <a routerLink="nos-produits/sirh">
                    <div class="produits-card1">
                        <div class="image-back">
                            <div class="image6"></div>
                        </div>
                        <h4 style="">SIRH</h4>
                        <p>Talents Gest Paie :
                            Un logiciel de paie, une solution qui prend en compte les réalités africaines. </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section>

<section
    style="padding: 20px 0px 20px; background: url('assets/img/back-pays.svg'); background-size: cover; background-position: center; background-repeat: no-repeat; color: #fff;">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-12 col-lg-12">
                <h2 class="customize-title" style="text-align: center;">Quelques chiffres clés</h2>
                <hr class="hh">
            </div>
            <div class="col-12 col-sm-3 col-lg-3">
                <div class="chiffre">
                    <h5 class="customize-title">+500</h5>
                    <p>Entreprises partenaires</p>
                </div>
            </div>
            <div class="col-12 col-sm-3 col-lg-3">
                <div class="chiffre">
                    <h4 class="customize-title">+7500</h4>
                    <p>Agents placés</p>
                </div>
            </div>
            <div class="col-12 col-sm-3 col-lg-3">
                <div class="chiffre">
                    <h2 class="customize-title">+100</h2>
                    <p>Enquêtes salariales</p>
                </div>
            </div>
            <div class="col-12 col-sm-3 col-lg-3">
                <div class="chiffre">
                    <h2 class="customize-title">+1000</h2>
                    <p>Bilans de compétences</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="formation">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-12 col-lg-6">
                <h2 class="customize-title">Nos formations</h2>
                <p class="section-title">Types de formations </p>

                <p>Nous vous offrons différents types de formations:</p>
                <ul>
                    <li><span>Intra-entreprise</span> (ces formations se déroulent au sein d’une entreprise, ce qui est
                        intéressant lorsque vous avez une équipe à former)</li>

                    <li><span>Inter-entreprises</span> (ces formations se déroulent suivant un calendrier bien précis et
                        vous
                        pouvez vous inscrire suivant votre convenance. Elles existent en : Internationales | Régionales
                        | Locales
                        Bénin | Locales Côte d'Ivoire.</li>

                    <li><span>Individuelles</span> ( vous vous inscrivez aux formations dont vous avez besoin à titre
                        individuel )
                    </li>
                    <li><span>Coaching</span>
                    </li>
                    <li><span>E-learning</span> ( vous vous inscrivez aux formations dont vous avez besoin en ligne )
                    </li>
                </ul>
                <div class="row mb-5">

                    <a routerLink="nos-produits/formation" class="btn btn-submit-second col-5"
                        style="margin-right: 20px;">En
                        savoir
                        plus</a>

                    <a href="contact/benin-tpc#formulaire" class="btn btn-submit-plus col-5 ">Contactez-nous</a>
                </div>
            </div>

            <div class="col-12 col-sm-12 col-lg-6" style="margin: auto;">
                <div class="row hz">
                    <div class="col-6">
                        <div class="card-formation">
                            <a href="nos-produits/formation"><img src="assets/img/form1.jpg" alt=""
                                    class="image-formation">
                                <div class="overlaye">
                                    <div class="text">Intra-entreprise</div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card-formation">
                            <a href="nos-produits/formation"><img src="assets/img/form2.jpg" alt=""
                                    class="image-formation">
                                <div class="overlaye">
                                    <div class="text">Inter-entreprises</div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card-formation">
                            <a href="nos-produits/formation"><img src="assets/img/traning.jpg" alt=""
                                    class="image-formation">
                                <div class="overlaye">
                                    <div class="text">Individuelle</div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card-formation">
                            <a href="nos-produits/formation"><img src="assets/img/form4.jpg" alt=""
                                    class="image-formation">
                                <div class="overlaye">
                                    <div class="text">Toutes le formations</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="newsletter"
    style="background: url('assets/img/back-news.svg'); background-size: cover; background-position: center; background-repeat: no-repeat;">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-7 col-lg-7">
                <h2 class="customize-title">Ne ratez plus rien</h2>
                <p>Abonnez-vous à nos newsletters. Selon vos centres d'intérêts, recevez nos offres d'emplois, nos avis
                    de
                    formations, des actualités sur l'entreprise. Abonnez-vous maintenant.</p>
            </div>
            <div class="col-12 col-sm-5 col-lg-5" style="margin: auto;">
                <form>
                    <div class="mb-3 col-md-12" style="padding: 0px !important;">
                        <!-- <label class="form-label">Votre email<span>*</span></label> -->
                        <input type="email" class="form-control" id="" placeholder="Email">
                    </div>
                    <div class="mb-3 col-md-12" style="padding: 0px !important;">
                        <button type="submit" class="btn btn-submit-white">Envoyer</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>

<section class="testimonials"
    style="background: url('assets/img/back-test.svg'); background-size: cover; background-position: center; background-repeat: no-repeat; padding: 50px 0px 40px 0px; display: none !important;">
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-5 col-lg-5 " style="margin: auto;">
                <p class="section-title"></p>
                <h2 class="customize-title">Témoignages</h2>
                <p>Nous avons plusieurs retours positifs de nos partenaires, associés et surtout de nos clients que nous
                    satisfaisons au jour le jour par notre expertise et dynamisme</p>

            </div>
            <div class="col-12 col-sm-7 col-lg-7 test-alg">
                <div class="test-card">
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cupiditate, deserunt!</p>
                    <b>Nom & Prénom</b>
                </div>
                <div class="test-card">
                    <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Repellendus, perspiciatis?</p>
                    <b>Nom & Prénom</b>
                </div>
                <div class="test-card">

                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque, ipsam?</p>
                    <b>Nom & Prénom</b>
                </div>
                <div class="test-card">

                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quis, architecto.</p>
                    <b>Nom & Prénom</b>
                </div>
            </div>
        </div>
    </div>

</section>
<script type="text/javascript">
    $('.owl-carousel').owlCarousel({
        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        rewindNav: false,
        autoplayHoverPause: false,
        autoplayTimeout: 8000,
        autoplay: true,
        pagination: false,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    });
</script>